/**
 * Escape a value for interpolation into an HTML template string (#149).
 *
 * For code that builds trusted markup and assigns it to `innerHTML` (the tour
 * popovers): every runtime value that is not itself trusted markup goes
 * through this, so `<img onerror>` in a product name renders as text.
 * To turn untrusted HTML into text instead, use `htmlToText`.
 */
export function escapeHtml(value: unknown): string {
    return String(value ?? '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;')
}
